import { inject } from '@angular/core';
import { signalStore, withState, withProps, withMethods, patchState } from '@ngrx/signals';
import { CaseDto } from '../../Models/CaseDto';
import { Router } from '@angular/router';

export interface CalculatorCaseSelectModalState {
  cases: CaseDto[],
  isLoadingCases: boolean
}

const initialCaseSelectState : CalculatorCaseSelectModalState = {
  cases: [],
  isLoadingCases: true,
};

export const CalculatorCaseSelectModalStore = signalStore(
  { providedIn: 'root' },
  withState(initialCaseSelectState),
  withProps(() => ({
    router: inject(Router),
  })),
  withMethods(({ router, ...store }) => ({
    loadCaseDto(caseDto: CaseDto[]): void {
      patchState(store, { cases: caseDto, isLoadingCases: false });
    },
    goToCalculator(caseIdHash: string): void {
      if (caseIdHash) {
        router.navigate(['case-details'], { state: { caseHashId: caseIdHash, openCalc: true } });
      }
    },
  })),
);
